export default function Footer() {
  return (
    <footer className="border-t border-stone-200 bg-stone-100 text-stone-500">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6 py-10">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <a href="#" className="flex items-center gap-2 whitespace-nowrap">
              <span className="flex h-7 w-7 items-center justify-center rounded bg-red-600 text-sm font-bold text-white">爆</span>
              <span className="font-serif text-xl font-black tracking-tight text-stone-900">暴走黑料</span>
            </a>
            <p className="mt-3 text-xs leading-6">
              紧盯黑料快速发酵全过程，拆解病毒传播、评论区沦陷与热搜登顶的完整引爆路径。全网扩散追踪，热搜登顶前必看。
            </p>
          </div>

          <div className="grid flex-1 grid-cols-2 gap-6 sm:grid-cols-3 md:max-w-xl">
            <div>
              <div className="text-xs font-bold tracking-wider text-stone-900">追踪观察</div>
              <ul className="mt-3 space-y-2 text-xs">
                <li><a href="#timeline" className="hover:text-red-600">引爆时间线</a></li>
                <li><a href="#board" className="hover:text-red-600">今日热度榜</a></li>
                <li><a href="#" className="hover:text-red-600">扩散快讯流</a></li>
              </ul>
            </div>
            <div>
              <div className="text-xs font-bold tracking-wider text-stone-900">路径拆解</div>
              <ul className="mt-3 space-y-2 text-xs">
                <li><a href="#" className="hover:text-red-600">病毒传播</a></li>
                <li><a href="#" className="hover:text-red-600">评论区沦陷</a></li>
                <li><a href="#" className="hover:text-red-600">热搜登顶</a></li>
              </ul>
            </div>
            <div>
              <div className="text-xs font-bold tracking-wider text-stone-900">关于</div>
              <ul className="mt-3 space-y-2 text-xs">
                <li><a href="#" className="hover:text-red-600">编辑部</a></li>
                <li><a href="#" className="hover:text-red-600">内容声明</a></li>
                <li><a href="#" className="hover:text-red-600">联系方式</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-3 border-t border-stone-200 pt-5 text-[11px] sm:flex-row sm:items-center">
          <p className="text-stone-400">© 2026 暴走黑料 · 全网扩散追踪站 · 内容与热度指标仅作观察演示用途</p>
          <p className="text-stone-400">话题引爆路径 · 热搜登顶倒计时 · 评论区沦陷预警</p>
        </div>
      </div>
    </footer>
  );
}